import React from "react";
import {DataNode} from "rc-tree/lib/interface";
import {RoleDto} from "@reside/reside-api-app";

import {AdminRoles} from "../../../atoms/admin-roles";
import {PccTag} from "../atoms/facility-settings-header/FacilitySettingsHeader";
import {PccIntegrationStatus} from "../../../services/PccService";

export const createFacilitiesTreeWithPccIcons = (
  facilitiesTree: ReadonlyArray<DataNode>,
) =>
  facilitiesTree.map(org => ({
    ...org,
    children: org.children?.map((facility: any) => ({
      ...facility,
      icon: (
        <AdminRoles roles={[RoleDto.NameEnum.RESIDE_ADMIN]}>
          <PccTag
            isVisible={
              facility.pccIntegrationStatus ===
                PccIntegrationStatus.PccTurnedOn ||
              facility.pccIntegrationStatus ===
                PccIntegrationStatus.PccTurnedOff
            }
            color={
              facility.pccIntegrationStatus === PccIntegrationStatus.PccTurnedOn
                ? "green100"
                : "deepOrange300"
            }
            outline={
              facility.pccIntegrationStatus ===
              PccIntegrationStatus.PccTurnedOff
            }
          >
            {facility.pccIntegrationStatus === PccIntegrationStatus.PccTurnedOn
              ? "PCC ON"
              : "PCC OFF"}
          </PccTag>
        </AdminRoles>
      ),
    })),
  }));
